import type { Option } from '@vaaas/fpts/option';
import './index.scss';
import { utility } from '@phi/components';
import { defineComponent, h, PropType } from 'vue';
import FileInput from '@frontend/components/FileInput';

export const DragAndDropFile = defineComponent({
    props: {
        type: {
            required: true,
            type: String,
        },

        value: {
            required: true,
            type: null as any as PropType<Option<File>>,
        },

        label: {
            required: false,
            type: String,
            default: 'Drag & drop a file from your computer',
        },
    },

    emits: {
        'update:value': (x: File) => true,
    },

    data() {
        return {
            highlight: false,
        };
    },

    methods: {
        dragEnter(e: Event) {
            this.highlight = true;
            e.preventDefault();
            e.stopPropagation();
        },

        dragOver(e: Event) {
            this.highlight = true;
            e.preventDefault();
            e.stopPropagation();
        },

        dragLeave(e: Event) {
            this.highlight = false;
            e.preventDefault();
            e.stopPropagation();
        },

        drop(e: DragEvent) {
            this.highlight = false;
            const dt = e.dataTransfer!;
            const files = Array.from(dt.files);
            if (files.length)
                this.$emit('update:value', files[0]!);
            e.preventDefault();
            e.stopPropagation();
        },
    },

    render() {
        return h('div', {
            class: {
                highlight: this.highlight,
                'select-local-file': true,
                [utility.round]: true,
                [utility.center]: true,
            },
            onDragenter: this.dragEnter,
            onDragover: this.dragOver,
            onDragleave: this.dragLeave,
            onDrop: this.drop,
        }, h('form', { class: utility.margin_gap_1 }, [
            h('div', this.label),
            h('div', 'or'),
            h(FileInput, {
                accept: this.type,
                value: this.value,
                label: 'Browse',
                'onUpdate:value': (x) => this.$emit('update:value', x),
            })
        ]));
    }
});
